import axios, { AxiosResponse } from 'axios';

// Import the new server-side proxy compatible functions
import { getApiConfig } from '@/lib/client-id-provider';

const api = axios.create({
  baseURL: '/api', // Always use server proxy endpoint
  timeout: 50000, // 50 segundos para coincidir com timeout da UI
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for server-side proxy compatibility
api.interceptors.request.use(
  config => {
    try {
      // Get userClientId from custom config if provided for V5 endpoints
      const userClientId = (config as any).userClientId;

      // Get API configuration for server-side proxy
      const proxyConfig = getApiConfig({
        endpoint: config.url || '',
        userClientId: userClientId,
      });

      // Merge proxy headers (x-user-client-id for V5 endpoints)
      if (proxyConfig.headers) {
        config.headers = {
          ...config.headers,
          ...proxyConfig.headers,
        };
      }
    } catch (error) {
      throw error;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor for logging and error handling
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * Helper function to add user context for V5 endpoints
 * @deprecated - kept for backward compatibility, use Services directly
 */
export function withUserContext(userClientId: string) {
  return {
    userClientId, // This will be used by the interceptor
  };
}

export { api };
